/* Players market — the supplier's full card list, pulled in stages by the shopper's browser (no server).
 * The Coin Printer answers 50 cards a call, allows 60 calls a minute per key for ALL visitors together, and takes
 * 10–140 s a call. So: one call at a time, progress kept in this browser and resumed on the next visit, a finished
 * list pulled again after a few hours, one pulling tab per browser, a minute's pause when the supplier is busy.
 * The section (sections/fc-players-market.liquid) owns the cards and hands over window.fcPlayersBridge:
 * { api, minRating, maxRating, isAr, text, map(apiItem), mapList(apiItems), setList(players), status(text, phase),
 *   done(listIsComplete) }. text = the status lines from the theme locales (fc_players.*), {got} / {all} = counts.
 */
(function () {
  'use strict';
  if (window.fcPlayersStages) return;

  var opt = window.fcPlayersStagesOptions || {}; // tests shorten the waits
  var TAKE = 50;
  var STORE_KEY = 'fcTcpStages_v1';
  var LOCK_KEY = 'fcTcpStages_lock';
  var FRESH_MS = opt.freshMs || 3 * 60 * 60 * 1000; // a list older than 3 hours is pulled again
  var LOCK_MS = opt.lockMs || 3 * 60 * 1000;        // a pulling tab renews its lock on every call
  var GAP_MS = opt.gapMs || 1500;                   // pause between two calls
  var BUSY_MS = opt.busyMs || 60 * 1000;            // after a 429, a time-out or a network error
  var CALL_MS = opt.callMs || 180 * 1000;           // one call is abandoned after 3 minutes
  var REFUSED_MS = opt.refusedMs || 60 * 60 * 1000; // after a refusal (bad token / query), try again in an hour
  var IMG = 'https://cdn3.futbin.com/content/fifa27/img/players/';
  var IMGQ = '?fm=png&ixlib=java-2.1.0&verzion='; // the part of the signed picture query every card shares
  var FIELDS = ['id', 'name', 'rating', 'position', 'alt_positions', 'image', 'group_type', 'console_price', 'pc_price',
    'team', 'league', 'nationality', 'pace', 'shooting', 'passing', 'dribbling', 'defending', 'physical'];
  var GEN = FIELDS.length; // a stored row ends with the pull that last saw the card

  var bridge = null;
  var st = null; // { v, scope, gen, page, total, done, complete, doneAt, startedAt, refusedAt, rows: { cardId: row } }
  var timer = null;
  var me = Math.random().toString(36).slice(2);

  function load(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function save(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; }
  }

  // Rows are arrays without key names, and the long signed picture URL loses its fixed parts: ~220 bytes a card
  // (7,855 cards ≈ 1.9 M characters; WebKit counts 2 bytes each against its 5 MB)
  function pack(item, gen) {
    var row = FIELDS.map(function (f) {
      var v = item[f];
      if (f === 'image' && typeof v === 'string' && v.indexOf(IMG) === 0) return '~' + v.slice(IMG.length).replace(IMGQ, '|');
      return v === undefined ? null : v;
    });
    row.push(gen);
    return row;
  }
  function unpack(row) {
    var item = {};
    FIELDS.forEach(function (f, i) {
      var v = row[i];
      item[f] = (f === 'image' && typeof v === 'string' && v.charAt(0) === '~') ? IMG + v.slice(1).replace('|', IMGQ) : v;
    });
    return item;
  }

  // The section merges the supplier's duplicate copies and maps the cards (the same code serves live search)
  function players() {
    var items = Object.keys(st.rows).map(function (id) { return unpack(st.rows[id]); });
    return bridge.mapList ? bridge.mapList(items) : items.map(bridge.map);
  }

  function show() {
    var list = players();
    if (list.length) bridge.setList(list);
  }

  // Status lines come from the section (bridge.text, the theme locales); these stand in for a line it does not hand
  // over. {got} / {all} = cards pulled so far / cards in the supplier's list
  var WORDS = {
    ar: {
      done: 'الأسعار حية ومحدثة مباشرة من سوق Ultimate Team',
      stopped: 'تعذر تحديث كروت السوق حالياً',
      busy: 'السوق مزدحم الآن • سنكمل تحميل الكروت بعد دقيقة',
      loading: 'جاري تحميل كروت السوق...',
      updating: 'جاري تحديث أسعار الكروت • {got} من {all}',
      progress: 'جاري تحميل كروت السوق • {got} من {all}'
    },
    en: {
      done: 'Live UT Market Prices',
      stopped: 'Market cards could not be updated right now',
      busy: 'Market busy • loading resumes in a minute',
      loading: 'Loading market cards...',
      updating: 'Updating card prices • {got} of {all}',
      progress: 'Loading market cards • {got} of {all}'
    }
  };
  function words(key) {
    return (bridge.text && bridge.text[key]) || WORDS[bridge.isAr ? 'ar' : 'en'][key];
  }
  function fill(text, vals) {
    return String(text).replace(/\{(\w+)\}/g, function (m, k) { return vals[k] !== undefined ? vals[k] : m; });
  }

  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function say(kind) {
    var got = fmt(Math.min(st.page * TAKE, st.total));
    var all = fmt(st.total);
    if (kind === 'done') {
      bridge.status(words('done'), 'done');
    } else if (kind === 'stopped') {
      bridge.status(words('stopped'), 'wait');
    } else if (kind === 'busy') {
      bridge.status(words('busy'), 'wait');
    } else if (!st.total) {
      bridge.status(words('loading'), 'loading');
    } else {
      bridge.status(fill(words(st.gen > 1 ? 'updating' : 'progress'), { got: got, all: all }), 'loading');
    }
  }

  // One pulling tab per browser: the others show what it saves (storage event)
  function haveLock() {
    var lock = load(LOCK_KEY);
    var now = Date.now();
    if (lock && lock.who !== me && lock.until > now) return false;
    save(LOCK_KEY, { who: me, until: now + LOCK_MS });
    return true;
  }
  function dropLock() {
    var lock = load(LOCK_KEY);
    if (lock && lock.who === me) {
      try { localStorage.removeItem(LOCK_KEY); } catch (e) {}
    }
  }

  function next(delay) {
    clearTimeout(timer);
    timer = setTimeout(pull, delay);
  }

  // Tells the section whether the cards on screen are a whole list (a re-pull keeps the last whole list on screen)
  function tellComplete() {
    if (bridge.done) bridge.done(!!(st.complete || st.done));
  }

  // Cards come page by page from a list that can shift during a 30-minute pull (ties in rating, new cards), so a card
  // missed in one pull may still be on sale: it is dropped only when two pulls in a row missed it
  function finish() {
    Object.keys(st.rows).forEach(function (id) {
      if (st.rows[id][GEN] < st.gen - 1) delete st.rows[id];
    });
    st.done = true;
    st.complete = true;
    st.doneAt = Date.now();
  }

  // What to do now: nothing (refused lately), wait until the list is 3 hours old, or pull (resume or start over)
  function plan() {
    var now = Date.now();
    clearTimeout(timer);
    if (st.refusedAt && now - st.refusedAt < REFUSED_MS) {
      say('stopped');
      timer = setTimeout(plan, st.refusedAt + REFUSED_MS - now + 1000);
      return;
    }
    // Fresh counts from the first page of the pull: those are the dearest cards and the oldest prices
    if (st.done && now - st.startedAt < FRESH_MS) {
      say('done');
      timer = setTimeout(plan, st.startedAt + FRESH_MS - now + 1000); // an open tab pulls again on time
      return;
    }
    // Stale (finished, or started too long ago): pull again from page 1; the old cards stay on screen meanwhile
    if (st.done || (st.startedAt && now - st.startedAt > FRESH_MS)) {
      st.gen += 1;
      st.page = 0;
      st.done = false;
    }
    say('loading');
    next(0);
  }

  function pull() {
    if (st.done) { // another tab finished the list meanwhile
      plan();
      return;
    }
    if (!haveLock()) {
      next(LOCK_MS / 3);
      return;
    }
    var page = st.page + 1;
    var url = bridge.api + '?version=all&take=' + TAKE + '&page=' + page + '&sort=rating&order=desc' +
      '&min_rating=' + encodeURIComponent(bridge.minRating) + '&max_rating=' + encodeURIComponent(bridge.maxRating);
    var ctrl = window.AbortController ? new AbortController() : null;
    var killer = ctrl ? setTimeout(function () { ctrl.abort(); }, CALL_MS) : null;
    fetch(url, {
      headers: { Accept: 'application/json' },
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        // 429 and 5xx are worth another try; any other refusal (bad token, bad query) is not
        if (res.status === 429 || res.status >= 500) throw { retry: true, status: res.status };
        if (!res.ok) throw { retry: false, status: res.status };
        return res.json();
      })
      .then(function (body) {
        clearTimeout(killer);
        var data = body && Array.isArray(body.data) ? body.data : [];
        var total = body && body.pagination ? body.pagination.total : null;
        st.total = typeof total === 'number' ? total : Math.max(st.total, page * TAKE);
        if (page === 1) st.startedAt = Date.now();
        delete st.refusedAt;
        data.forEach(function (item) {
          if (item && item.id) st.rows[item.id] = pack(item, st.gen);
        });
        st.page = page;
        var last = data.length < TAKE || page * TAKE >= st.total;
        if (last) finish();
        if (!save(STORE_KEY, st)) console.warn('Players market: browser storage is full, the card list lives in this tab only');
        tellComplete();
        show();
        if (last) {
          dropLock();
          plan();
        } else {
          say('loading');
          next(GAP_MS);
        }
      })
      .catch(function (err) {
        clearTimeout(killer);
        if (err && err.retry === false) {
          console.warn('Players market: the supplier refused the card list (HTTP ' + err.status + ')');
          st.refusedAt = Date.now();
          save(STORE_KEY, st);
          dropLock();
          plan();
          return;
        }
        say('busy');
        next(BUSY_MS);
      });
  }

  // Another tab saved progress: show it, unless this tab is the one pulling or the save is older than ours
  function onStorage(e) {
    if (e.key !== STORE_KEY || !e.newValue) return;
    var lock = load(LOCK_KEY);
    if (lock && lock.who === me && lock.until > Date.now()) return;
    var saved = null;
    try { saved = JSON.parse(e.newValue); } catch (x) { return; }
    if (!saved || saved.v !== 1 || saved.scope !== st.scope) return;
    if (saved.gen < st.gen || (saved.gen === st.gen && !saved.done && saved.page < st.page)) return;
    st = saved;
    tellComplete();
    show();
    if (st.done) plan(); // stops this tab's waiting timer: nothing left to pull until the list is 3 hours old
    else say('loading');
  }

  function start(b) {
    if (bridge || !b || !b.api) return;
    bridge = b;
    var scope = b.minRating + '-' + b.maxRating;
    st = load(STORE_KEY);
    if (!st || st.v !== 1 || st.scope !== scope || !st.rows || typeof st.rows !== 'object') {
      st = { v: 1, scope: scope, gen: 1, page: 0, total: 0, done: false, complete: false, doneAt: 0, startedAt: 0, rows: {} };
    }
    window.addEventListener('storage', onStorage);
    window.addEventListener('pagehide', dropLock);
    tellComplete();
    if (Object.keys(st.rows).length) show();
    plan();
  }

  window.fcPlayersStages = { start: start };
  if (window.fcPlayersBridge) start(window.fcPlayersBridge);
})();
